






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState, mapMutations } from "vuex";
import SidebarToggleButton from "@/components/SidebarToggleButton.vue";
import { isNewProject } from "@/preferences";

@Component({
  computed: mapState(["projectSidebarFileVisible"]),
  methods: mapMutations(["showProjectSidebarFile", "hideProjectSidebarFile"]),
  components: {
    SidebarToggleButton
  }
})
export default class ProjectSidebar extends Vue {
  @Prop({ type: String, required: true }) projectId!: string;
  @Prop({ type: Boolean }) readonly!: boolean;

  get sidebarCollapsed() {
    return !this.$store.state.projectSidebarExpanded;
  }

  toggle(collapsed: boolean) {
    console.warn(collapsed);
    this.$store.state.projectSidebarExpanded = !collapsed;
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get sidebar() {
    if (this.sidebarCollapsed) {
      return "sidebar";
    } else {
      return "sidebar sidebar-expand-md";
    }
  }

  get linkToOrderManagementScreen() {
    const project = this.$store.state.project;
    const isProjectCreated = project && project.created;

    if (isProjectCreated) {
      const createdTime = project.created;
      return `/projects/${this.projectId}/${
        isNewProject(createdTime) ? "orders/" : ""
      }estimates`;
    }

    return `/projects/${this.projectId}/estimates`;
  }

  get linkToSaleReportScreen() {
    const project = this.$store.state.project;
    const isProjectCreated = project && project.created;

    if (isProjectCreated) {
      const createdTime = project.created;
      return `/projects/${this.projectId}/${
        isNewProject(createdTime) ? "orders/" : ""
      }sales-report`;
    }

    return `/projects/${this.projectId}/sales-report`;
  }

  get isNewProject() {
    const project = this.$store.state.project;
    const isProjectCreated = project && project.created;

    if (isProjectCreated) {
      const createdTime = project.created;
      return isNewProject(createdTime);
    }
    return false;
  }
}
